'use strict';

var configService = require('vimmi-web-utils/cjs/configService');
var device = require('vimmi-web-utils/cjs/device');
var localStore = require('vimmi-web-utils/cjs/localStore');
var screenMode = require('vimmi-web-utils/cjs/screenMode');
var makeHash = require('vimmi-web-utils/cjs/makeHash');
var doFetch = require('vimmi-web-utils/cjs/doFetch');
var getCurrentProtocol = require('vimmi-web-utils/cjs/getCurrentProtocol');
var normDomain = require('vimmi-web-utils/cjs/normDomain');
var normalizeLang = require('vimmi-web-utils/cjs/normalizeLang');

const Config = new configService.ConfigService();

class Buffer {
    constructor() {
        this._eventsBuffer = [];
    }
    putInbBuffer(eventArg) {
        this._eventsBuffer.push(eventArg);
    }
    send(...eventArg) {
    }
    freeBuffer() {
        if (this._eventsBuffer.length) {
            let buffer = [...this._eventsBuffer];
            this._eventsBuffer = [];
            while (buffer.length) {
                let eventArg = buffer.shift();
                this.send(...eventArg);
            }
        }
    }
}

/** List of all available events types*/
// export const EVENT_TYPES = {
//     APP: 'app',
//     MEDIA: 'media',
//     //  AMS: 'ams',
//     //  CDN: 'cdn',
//     AD: 'advertising',
// };
// export class SDKError extends Error {
//     public err_name: string;
//     public err_code: number;
//
//     constructor(args: any) {
//         super(args);
//     }
// }
//
// export const ERROR_CODES = {
//     6: {
//         name: 'INTERNAL',
//         description: 'The SDK internal error',
//     },
//     4: {
//         name: 'NETWORK',
//         description: 'The browser doesn\'t supports!',
//     },
//     5: {
//         name: 'SERVER',
//         description: 'Server error',
//     },
//     7: {
//         name: 'BROWSER',
//         description: 'The browser doesn\'t supports!',
//     },
// };
/** FBQ */
const FBQ_EVENTS_MAP = {
    'PageView': 'track',
    'Purchase': 'track',
};
/** BUH **/
const EVENTS_MAP = {
    'app_open': 'app',
    'app_ready': 'app',
    'app_paused': 'app',
    'app_closed': 'app',
    'app_error': 'app',
    'auth_sent': 'app',
    'sync_sent': 'app',
    'screen_request': 'app',
    'play_request': 'app',
    'auth_ok': 'app',
    'auth_error': 'app',
    'sync_ok': 'app',
    'sync_error': 'app',
    'screen_ready': 'app',
    'page_elem_shown': 'app',
    'play_response': 'app',
    'play_error': 'app',
    'try_play_premium': 'app',
    'sid_create': 'app',
    'ams_request': 'app',
    'ams_response': 'app',
    'item_related': 'app',
    'purchase': 'app',
    'recommendation': 'app',
    'app_hidden': 'app',
    'app_shown': 'app',
    'screen_response': 'app',
    'popup_shown': 'app',
    'popup_clicked': 'app',
    'banner_click': 'app',
    'fungus_login_attempt': 'app',
    'fungus_login_success': 'app',
    'user_interaction': 'app',
    'share_item': 'app',
    'external_application_opened': 'app',
    'products_updated': 'app',
    'favorite_item': 'app',
    'unfavorite_item': 'app',
    'product_offer_played_on': 'app',
    'search': 'app',
    'notification_recieved': 'app',
    'notification_action': 'app',
    'set_pn_permission': 'app',
    'fungus_login_failure': 'app',
    'fungus_logout_attempt': 'app',
    'fungus_logout_success': 'app',
    'fungus_logout_failure': 'app',
    'first_run': 'app',
    'upgrade': 'app',
    'in_box_open': 'app',
    'ad_show': 'advertising',
    'ad_skip': 'advertising',
    'ad_ignored': 'advertising',
    'ad_clicked': 'advertising',
    'meta_request': 'media',
    'meta_response': 'media',
    'meta_error': 'media',
    'player_ready': 'media',
    'media_is_playing': 'media',
    'start': 'media',
    'chu': 'media',
    'seek': 'media',
    'stop': 'media',
    'abort': 'media',
    'media_buffering_start': 'media',
    'media_buffering_completed': 'media',
    'media_error': 'media',
    'media_is_playineg': 'media',
    'media_pause': 'media',
    'media_resume': 'media',
    'media_bitrate_switch': 'media',
    'media_audio_switch': 'media',
    'media_subtitle_switch': 'media',
    'media_screen_switch': 'media',
    'media_cast': 'media',
    'dl_start': 'media',
    'dl_pause': 'media',
    'dl_error': 'media',
    'dl_completed': 'media',
};

class BuhDriver {
    constructor() {
        this.logger = console;
        this._buffer = [];
        this._packageInterval = null;
        this.packaging = true;
        this.options = { ep: null };
        this.defaultPackageOptions = {
            minEvents: 40,
            maxEvents: 50,
        };
        if (localStore.localStore.get('buhEventsBuffer')) {
            try {
                this._buffer = JSON.parse(localStore.localStore.get('buhEventsBuffer'));
            }
            catch (e) {
                console.warn('cannot parse evens buffer from localStorage!');
            }
        }
    }
    get buhDeviceInfo() {
        return `${Config.get('app_id') || 'vimmi.' + this.deviceType}, ${Config.get('customBrowserName') || device.device.getBrowserName() ||
            'unknown'}, AppVersion: ${Config.get('app_version') || '0.0.0'}, ${device.device.getOsVersion() ||
            'unknown'}, Language: ${Config.get('language') || 'unknown'}`;
    }
    get deviceType() {
        return Config.get('platform') || 'web';
    }
    get customDeviceIdPart() {
        if (Config.get('buhDeviceId')) {
            return Config.get('buhDeviceId');
        }
        else if (!localStore.localStore.get('buh_device_id_part')) {
            localStore.localStore.set('buh_device_id_part', makeHash.makeHash(32));
        }
        return localStore.localStore.get('buh_device_id_part');
    }
    async applyConf() {
        if (Config.get('drivers.buh.buhsy') === false) {
            this.disablePackaging();
        }
        else {
            if (Config.get('drivers.buh.package')) {
                this.enablePackaging();
            }
            else {
                this.disablePackaging();
            }
        }
        return true;
    }
    enablePackaging() {
        this.packaging = true;
        let prevInterval = this.options.egap;
        this.options = Object.assign({ packageOpt: this.defaultPackageOptions }, Config.get('drivers.buh') || {});
        if (this._packageInterval && prevInterval === Config.get('drivers.buh.egap')) {
            // the same interval already initialized
            return;
        }
        if (this._packageInterval) {
            this.destroyPackageInterval();
        }
        if (this.options.egap) {
            if (Config.get('debug')) {
                this.logger.log('[VimmiAI][BUH] initialize package listener', this.options.egap);
            }
            this._packageInterval = setInterval(async () => {
                if (Config.get('debug')) {
                    this.logger.log('[VimmiAI][BUH] send package by interval');
                }
                await this.handlePackage({ package: true });
            }, this.options.egap * 1000);
        }
    }
    disablePackaging() {
        this.packaging = false;
        this.destroyPackageInterval();
    }
    destroyPackageInterval() {
        if (this._packageInterval) {
            clearInterval(this._packageInterval);
            this._packageInterval = null;
        }
    }
    prepareEventData(evn, options) {
        let eventType = EVENTS_MAP[evn];
        let data = {
            evn: evn,
            etype: eventType,
            ts: Date.now() / 1000,
            network: device.device.connectionType(),
            version: Config.get('sdk_version'),
            // app_info: (Config.get('app_info') || ""),
            // app_version: `${Config.get('version')}`,
            // customer: Config.get('customer'),
            device_type: this.deviceType,
            device_id: (this.deviceType || '').toLowerCase() === 'web' ? `${Config.get('device_id')}_web_${this.customDeviceIdPart}` : Config.get('device_id'),
            screen_mode: screenMode.screenMode(),
            device_os: `${device.device.getOsName() || 'unknown'}: ${device.device.getOsVersion() || 'unknown'}`,
            language: Config.get('language'),
            device_info: this.buhDeviceInfo,
        };
        if (options.buffer_timestamp) {
            data.ts = options.buffer_timestamp / 1000;
        }
        return data;
    }
    async handlePackage(options = {}) {
        if (Config.get('drivers.buh.buhsy') === false) {
            return null;
        }
        if (this._buffer.length) {
            if (Config.get('debug')) {
                this.logger.log('[VimmiAI][BUH][handlePackage]', this._buffer.length, [...this._buffer]);
            }
            localStore.localStore.set('buhEventsBuffer', []);
            let res = await this.sendToBackend(this._buffer.splice(0, this.options.packageOpt.maxEvents), options);
            if (Config.get('debug')) {
                this.logger.log('[VimmiAI][BUH][handlePackage] leave events in buffer', this._buffer.length, [...this._buffer], res);
            }
            return res;
        }
    }
    async sendToBackend(eventData, options = {}) {
        if (Config.get('drivers.buh.buhsy') === false) {
            return null;
        }
        options = options || {};
        let url = this.formatBackendUrl(options.package ? 'package' : eventData.evn, !!options.package);
        // console.log('sendToBackend.options', options);
        /*      if (options.beacon && (options.fetch === undefined || options.fetch) && window.fetch) {
                  if (Config.get('debug')) {
                      this.logger.info(`Sending ${options.package ? "package" : ''} as fetch, events: \n${JSON.stringify(eventData, null, ' ')}`);
                  }
                  return fetch(url, {
                      method: 'POST',
                      body: JSON.stringify(eventData),
                      keepalive: true
                  }).then((result) => {
                      return true;
                  });
              } else*/
        if (options.beacon && navigator.sendBeacon && !Config.get('drivers.buh.headers')) {
            if (Config.get('debug')) {
                this.logger.info(`[VimmiAI][BUH] Sending ${options.package ? "package" : ''} as beacon, events: \n${JSON.stringify(eventData, null, ' ')}`);
            }
            let blob = new Blob([JSON.stringify(eventData)], {
                type: 'text/plain; charset=UTF-8',
            });
            let res = navigator.sendBeacon(url, blob);
            if (Config.get('debug')) {
                this.logger.info(`[VimmiAI][BUH] beacon res`, res);
            }
            return res;
        }
        else {
            if (Config.get('debug')) {
                this.logger.info(`[VimmiAI][BUH] Sending ${options.package ? "package" : ''} events: \n${JSON.stringify(eventData, null, ' ')}`);
            }
            return doFetch.doFetch(url, {
                headers: Config.get('drivers.buh.headers') || {},
                method: 'post',
                keepalive: true,
                body: JSON.stringify(eventData)
            })
                .then((result) => {
                return true;
            })
                .catch((error) => {
                if (Config.get('debug')) {
                    this.logger.error('[VimmiAI][BUH]', error);
                }
                throw error;
            });
        }
    }
    async send(event, extra_data = null, options = {}) {
        if (Config.get('drivers.buh.buhsy') === false) {
            return;
        }
        if (!EVENTS_MAP[event]) {
            this.logger.warn(new Error(`the "BuhDriver" driver doesn\'t support this event: ${event}`));
            return false;
        }
        // ещё один буфер (один из вариантов)
        options = options || {};
        let eventData = Object.assign({}, this.prepareEventData(event, options), extra_data);
        if (this.packaging) {
            this._buffer.push(eventData);
            if (this._buffer.length >= this.options.packageOpt.minEvents || options.beacon) {
                let result = await this.handlePackage({
                    package: true,
                    ...options
                });
                return result;
            }
            else {
                localStore.localStore.set('buhEventsBuffer', JSON.stringify(this._buffer));
            }
            return {
                buffered: true
            };
        }
        else {
            return this.sendToBackend(eventData, options);
        }
    }
    async beforePageClose(options) {
        if (this.packaging && Config.get('drivers.buh.buhsy') !== false) {
            if (Config.get('debug')) {
                this.logger.log('[VimmiAI][BUH][beforePageClose]', this._buffer.length, [...this._buffer]);
            }
            return this.handlePackage(Object.assign({ beacon: true, fetch: false, package: true }, options));
        }
        return null;
    }
    formatBackendUrl(evn, isPackage) {
        let url = `${getCurrentProtocol.getCurrentProtocol()}//${normDomain.normDomain(Config.get('drivers.buh.ep'))}${Config.get('drivers.buh.customPath') || '/event/evn/'}`;
        return url + (Config.get('NODE_ENV') === 'development' && !isPackage && !Config.get('drivers.buh.customPath') ? `?evn=${evn}` : '');
    }
    destroy() {
        this.disablePackaging();
    }
}

class FBQDriver {
    constructor() {
        this.currentPixelId = null;
        this.fbq = null;
        this.logger = console;
    }
    async applyConf() {
        // if (this.fbq) {
        //     return true;
        // }
        if (Config.get('drivers.fbq.pixelId')) {
            await this.loadSdk();
        }
        return true;
    }
    send(event, extra_data, options) {
        if (!FBQ_EVENTS_MAP[event]) {
            // this.logger.warn(new Error(`the "FBQDriver" driver doesn\'t support this event: ${event}`));
            return false;
        }
        let eventType = FBQ_EVENTS_MAP[event];
        let eventData = Object.assign({}, extra_data || {});
        if (Object.values(eventData).length) {
            this.fbq(eventType, event, eventData);
        }
        else {
            this.fbq(eventType, event);
        }
        return true;
    }
    async loadSdk() {
        return new Promise((resolve) => {
            // @ts-ignore
            if (window.fbq) {
                // @ts-ignore
                this.fbq = window.fbq;
                return;
            }
            if (this.fbq && (this.currentPixelId && this.currentPixelId === Config.get('drivers.fbq.pixelId')))
                return;
            this.currentPixelId = Config.get('drivers.fbq.pixelId');
            let $this = this;
            // @ts-ignore
            this.fbq = window.fbq = function () {
                $this.fbq.callMethod ? $this.fbq.callMethod.apply($this.fbq, arguments) : $this.fbq.queue.push(arguments);
            };
            // @ts-ignore
            if (!window._fbq)
                window._fbq = this.fbq;
            this.fbq.push = this.fbq;
            this.fbq.loaded = true;
            this.fbq.version = '2.0';
            this.fbq.queue = [];
            let script = document.createElement('script');
            script.async = true;
            script.src = 'https://connect.facebook.net/en_US/fbevents.js';
            let head = document.getElementsByTagName('script')[0];
            head.parentNode.insertBefore(script, head);
            script.onload = (event) => {
                this.onLoaded();
                resolve(true);
            };
            script.onerror = (event) => {
                resolve(false);
            };
        });
    }
    onLoaded() {
        this.fbq('init', Config.get('drivers.fbq.pixelId'));
    }
    destroy() {
    }
}

class VimmiAnalytics extends Buffer {
    constructor() {
        super();
        this.drivers = {};
        this.logger = console;
        this.driversSetup = false;
        Config.set('sdk_version', "2.0.77");
        Config.set('buildDate', "2021-07-30T12:59:22.303Z");
        Config.set('NODE_ENV', process.env.NODE_ENV);
        this.logger.info(`VimmiAnalytics(Version: ${Config.get('sdk_version')}, Build date: ${Config.get('buildDate')})`);
    }
    conf(first, second, driver) {
        if (typeof first === 'string' && second) {
            Config.set(first, second);
        }
        else if (typeof first === 'object' && !second) {
            if (driver && Object.values(VimmiAnalytics.DRIVERS).indexOf(driver) !== -1) {
                Config.set(`drivers.${driver}`, first);
                if (this.drivers[driver]) {
                    this.drivers[driver].applyConf();
                }
            }
            else if (!driver) {
                Config.set(first);
            }
        }
        if (Config.get('language')) {
            Config.set('language', normalizeLang.normalizeLang(Config.get('language'), 'iso-3'));
        }
        if (Config.get('device_id')) {
            this.freeBuffer();
        }
    }
    debug(status = true) {
        return Config.set('debug', status);
    }
    get(key) {
        return Config.get(key);
    }
    async setDriver(driver = null, options = {}) {
        options = options || {};
        if (driver && Object.values(VimmiAnalytics.DRIVERS).indexOf(driver) !== -1) {
            Config.set(`drivers.${driver}`, options);
            if (VimmiAnalytics.DRIVERS.BUH === driver) {
                if (!this.drivers[driver]) {
                    this.drivers[driver] = new BuhDriver();
                }
            }
            else if (VimmiAnalytics.DRIVERS.FBQ === driver) {
                if (!this.drivers[driver]) {
                    this.drivers[driver] = new FBQDriver();
                }
            }
            return await this.drivers[driver].applyConf();
        }
        return false;
    }
    delDriver(driver = null) {
        if (driver && this.drivers[driver]) {
            this.drivers[driver].destroy();
            delete this.drivers[driver];
            return true;
        }
        return false;
    }
    /**
     * need to call after all drivers initialization
     * */
    initialize() {
        if (Config.get('debug')) {
            this.logger.log('drivers:', Object.keys(this.drivers));
        }
        if (!Object.keys(this.drivers).length) {
            return new Error('No one driver was set up!');
        }
        this.driversSetup = true;
        this.freeBuffer();
        return null;
    }
    send(event, extraData = {}, options = {}) {
        if (!this.driversSetup || !Object.keys(this.drivers).length) {
            options.buffer_timestamp = options.buffer_timestamp || Date.now();
            this.putInbBuffer([event, extraData, options]);
        }
        else {
            options = options || {};
            for (let type in this.drivers) {
                if (this.drivers[type] && (!options.only || options.only.indexOf(type) !== -1)) {
                    if (type === 'buh' && !Config.get('device_id')) {
                        options.buffer_timestamp = options.buffer_timestamp || Date.now();
                        this.putInbBuffer([event, extraData, options]);
                    }
                    else {
                        this.drivers[type].send(event, extraData || {}, options);
                    }
                }
            }
        }
    }
    /**
     * @description need to send drivers buffered events before page close, or need just to send some event with 'beacon': true
     * */
    beforePageClose(options = {}) {
        let promises = [];
        if (!this.driversSetup) {
            return false;
        }
        this.freeBuffer();
        for (let type in this.drivers) {
            if (this.drivers[type] && this.drivers[type].beforePageClose) {
                promises.push(this.drivers[type].beforePageClose(options));
            }
        }
        return Promise.all(promises);
    }
    getEventType(event) {
        return event ? EVENTS_MAP[event] || FBQ_EVENTS_MAP[event] || null : null;
    }
}
VimmiAnalytics.DRIVERS = {
    BUH: 'buh',
    FBQ: 'fbq'
};

// import "core-js/stable/object/values";

module.exports = VimmiAnalytics;
